export enum Role {
    ADMIN,
    VIEWER,
    EDITOR,
    READONLY,
    TAXPAYER_DB
  }